import { FirebaseApp, getApp, getApps, initializeApp } from "firebase/app";
import { Auth, getAuth, signInWithCustomToken } from "firebase/auth";
import { SignOutActions } from "@/redux/slice/auth/types/SignOutActions";
import { SignInActions } from "@/redux/slice/auth/types/SignInActions";
import { NEXT_PUBLIC_FIREBASE_API_KEY, NEXT_PUBLIC_FIREBASE_PROJECT_ID, NEXT_PUBLIC_NODE_ENV } from "./constants/auth";

const isProd = NEXT_PUBLIC_NODE_ENV === "production";

class FireBaseClient {
  private static client: FireBaseClient = null;
  private app: FirebaseApp = null;
  private auth: Auth = null;
  private projectId = NEXT_PUBLIC_FIREBASE_PROJECT_ID;
  private apiKey = NEXT_PUBLIC_FIREBASE_API_KEY;

  static createInstance() {
    this.client = new FireBaseClient();
  }

  static getInstance() {
    if (!this.client) {
      this.createInstance();
    }

    return this.client;
  }

  constructor() {
    this.buildFirebaseClient();
  }

  private buildFirebaseClient() {
    const app = !getApps().length ? initializeApp(this.getFirebaseConfig()) : getApp();
    const auth = getAuth(app);

    this.app = app;
    this.auth = auth;
  }

  getApp() {
    return this.app;
  }

  getAuth() {
    return this.auth;
  }

  getProjectId() {
    return this.projectId;
  }

  getApiKey() {
    return this.apiKey;
  }

  getFirebaseConfig() {
    const projectId = this.getProjectId();
    const apiKey = this.getApiKey();

    const firebaseProdConfig = {
      projectId,
      apiKey,
      appId: "1:537093214409:web:4eec27a7bc6bc1c8",
      authDomain: `${projectId}.firebaseapp.com`,
      databaseURL: `https://${projectId}.firebaseio.com`,
      messagingSenderId: "537093214409",
      storageBucket: "",
    };

    const firebaseNonProdConfig = {
      projectId,
      apiKey,
      authDomain: `${projectId}.firebaseapp.com`,
      storageBucket: `${projectId}.appspot.com`,
      messagingSenderId: "182613174943",
      appId: "1:182613174943:web:a5aa2f09bcbc7aa85ad0aa",
      measurementId: "G-4G2V1KBE5N",
    };

    return isProd ? firebaseProdConfig : firebaseNonProdConfig;
  }

  signOut(actions: SignOutActions) {
    return this.auth.signOut().then(() => {
      actions.dispatchSignOutUpdates();
    });
  }

  customSignIn(ssoToken: string, actions: SignInActions) {
    signInWithCustomToken(this.auth, ssoToken).then((userCredential) => {
      const currentUser = userCredential.user;
      actions.dispatchUpdateNewUser(currentUser.metadata.creationTime === currentUser.metadata.lastSignInTime);
      currentUser.getIdToken().then((token) => {
        actions.dispatchUpdateAuthToken(token);
        if (currentUser.refreshToken) localStorage.setItem("refreshToken", currentUser.refreshToken);
      });
    });
  }
}

export default FireBaseClient;
